import {calculateMaximumMortgageByIncomeApi, calculateMonthlyCostsByMortgage} from './calculationsApi'
import {
  getAdditionalEnergyLabelAmount
} from "./helpers";

export const calculateByIncome = (data) => {

    let isNhg = false;

    return calculateMaximumMortgageByIncomeApi(data)
        .then((response) => {
            data.maxMortgageAmount = response.maxMortgageAmount;
            data.Interest = (data.SelectedMortgageProvider) ? data.SelectedMortgageProvider.rentestand : response.interest;
            if (typeof response.isNhg !== 'undefined') {
              isNhg = response.isNhg;
            }
            return calculateMonthlyCostsByMortgage(data);

        }).then(function _monthlyCosts(response) {
            response.maxMortgageAmount = data.maxMortgageAmount;
            response.interest = data.Interest;
            response.isNhg = isNhg;
            return response;
        });
};

const sustainabilityUplift = (cleanData, calculatedData) => {
  //console.log('sustainabilityUplift', cleanData.EnergyLabel);
  const energyLabel  = cleanData.EnergyLabel?.value;
  calculatedData.maxMortgageAmount += getAdditionalEnergyLabelAmount(energyLabel, false);
  if (!calculatedData.isHouseAffordable) {
    if (calculatedData.totalNeededToBuyHouse < calculatedData.maxMortgageAmount) {
      calculatedData.isHouseAffordable = true;
    }
  }
  return calculatedData;
}




export const rewriteApiData = (cleanData, calculatedData) => {
  return sustainabilityUplift(cleanData, calculatedData);
}

